import React from 'react'
import { YMInitializer } from 'react-yandex-metrika'
import helpers from 'core/helpers'
import { default as ym_ } from 'react-yandex-metrika'

//const accounts = [47509558]
const accounts = [90585293]
const disableMetrika = window.spconfig.disableMetrika || window.location.host === 'localhost:8080'
export function ym(methodName: string, goalName: string): void {
    if (helpers.isProd() && !disableMetrika) {
        ym_(methodName, goalName)
    }
}

const YandexMetrika = () => {
    return helpers.isProd() && !disableMetrika ? (
        <YMInitializer
            accounts={accounts}
            options={{
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
                trackHash: true,
            }}
        />
    ) : null
}

export default YandexMetrika
